import PromotionCombosPage from 'pages/PromotionCombos/PromotionCombosPage';
import PromotionComboFormPage from 'pages/PromotionCombos/PromotionComboFormPage';

const promotionCombosRoute = [
  {
    path: '/promotion-combos/add',
    exact: true,
    name: 'Thêm mới combo/Bộ sản phẩm',
    function: 'PROMOTION_COMBO_ADD',
    component: PromotionComboFormPage,
  },
  {
    path: '/promotion-combos/edit/:comboId',
    exact: true,
    name: 'Chỉnh sửa combo/Bộ sản phẩm',
    function: 'PROMOTION_COMBO_EDIT',
    component: PromotionComboFormPage,
  },
  {
    path: '/promotion-combos',
    exact: true,
    name: 'Danh sách combo/Bộ sản phẩm',
    function: 'PROMOTION_COMBO_VIEW',
    component: PromotionCombosPage,
  },
];

export default promotionCombosRoute;
